import { useMemo } from 'react';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: getIcon('ic_dashboard'),
  applicants: getIcon('ic_user'),
  subjects: getIcon('ic_booking'),
  grades: getIcon('ic_kanban'),
};

export default function useNavConfig() {
  return useMemo(
    () => [
      {
        subheader: 'Boshqaruv',
        items: [
          { title: 'Bosh sahifa', path: '/dashboard/app', icon: ICONS.dashboard },
          { title: "O'quvchilar", path: '/dashboard/applicants', icon: ICONS.applicants },
          { title: 'Fanlar', path: '/dashboard/subjects', icon: ICONS.subjects },
          { title: 'Sinflar', path: '/dashboard/grades', icon: ICONS.grades },
        ],
      },
    ],
    []
  );
}
